import { AccountCircleOutlined } from '@mui/icons-material';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import { Box, Card, Typography } from '@mui/material';
import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { EModules } from '../../../../../shared/enums/modules/EModules';
import { ERole } from '../../../../../shared/enums/user/ERole';
import { ETheme } from '../../../../../shared/enums/user/ETheme';
import { IUser } from '../../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../../shared/mui/palettes';
import { RootState } from '../../../../../store/store';

const ICONS_MAP = {
  myProfile: AccountCircleOutlined,
  attendance: RestoreIcon,
  projects: AccountTreeOutlinedIcon,
  leaveDays: BeachAccessOutlinedIcon,
};

const leftCardKeys = [
  {
    name: 'myProfile',
  },
  {
    name: 'attendance',
    module: EModules.ATTENDANCE,
    hidable: true,
  },
  {
    name: 'projects',
    module: EModules.PROJECTS,
  },
  {
    name: 'leaveDays',
    module: EModules.LEAVE_DAYS,
    hidable: true,
  },
];

interface IProps {
  activeTab: string;
  setActiveTab: React.Dispatch<SetStateAction<string>>;
}
const EmployeePreviewLeftCard = ({ activeTab, setActiveTab }: IProps) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const modules = useSelector((state: RootState) => state.module?.list);
  const {
    theme,
    id: userId,
    role,
  } = useSelector((state: RootState) => state.auth.userData) as IUser;
  const isNormalUser = role === ERole.USER;
  const hidePersonalField = isNormalUser && userId !== Number(id);

  return (
    <Card
      sx={{
        mt: '20px',
        p: 0,
        display: { xs: 'flex', lg: 'block' },
        justifyContent: { xs: 'space-evenly', lg: 'flex-start' },
      }}
    >
      {leftCardKeys
        ?.filter(
          (profileKey) =>
            role === ERole.DEVELOPER ||
            !profileKey?.module ||
            modules?.some((module) => module?.name === profileKey?.module),
        )
        ?.filter((profileKey) => !hidePersonalField || !profileKey?.hidable)
        ?.map((profileKey) => {
          const isActive = profileKey?.name === activeTab;
          const IconComponent =
            ICONS_MAP?.[profileKey.name as keyof typeof ICONS_MAP];
          return (
            <Box
              key={profileKey?.name}
              onClick={() => setActiveTab(profileKey?.name)}
              className={'cursor-pointer'}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'center', lg: 'flex-start' },
                p: '15px',
                backgroundColor: isActive ? 'var(--primaryColor)' : undefined,
                width: { xs: '25%', lg: 'auto' },
              }}
            >
              <IconComponent
                sx={{
                  fill: isActive
                    ? '#fff'
                    : theme === ETheme.LIGHT
                      ? darkPalette.background.default
                      : lightPalette.background.default,
                }}
              />

              <Typography
                variant={'body2'}
                sx={{
                  ml: '5px',
                  color: isActive ? lightPalette.background.default : undefined,
                  display: { xs: 'none', md: 'block' },
                }}
              >
                {t(`header.${profileKey?.name}`)}
              </Typography>
            </Box>
          );
        })}
    </Card>
  );
};

export default EmployeePreviewLeftCard;
